module.exports = __webpack_public_path__ + "static/img/email.2d9a4eb3.png";